<template>
	<div class="content">
		<h3>物流码防伪码互查</h3>
		<div class="item">
			<el-form ref="form" inline  :model="form" label-width="100px">
                <el-form-item label="请输入数码">
					<el-input v-model="form.factoryName"></el-input>
				</el-form-item>
			</el-form>
			<div class="btn">
				<el-button type="primary"  @click="SelFactory">查 询</el-button>
				<el-button type="warning">重 置</el-button>
			</div>
		</div>
		<div class="item">
			<el-table :data="tableData" border>
				<el-table-column align="center" prop="Address" label="查询数码"></el-table-column>
                <el-table-column align="center" prop="Address" label="查询结果"></el-table-column>
			</el-table>
            <el-pagination
			background
			@current-change="handleCurrentChange"
			layout="total,prev, pager, next,jumper"
			:total="pageNum"
			:page-size="10">
			</el-pagination>
		</div>
	</div>
</template>

<script>
import {validateNumber} from '../utils/rules'
export default {
	data(){
		return {
			tableData: [],
			form:{

            },
			rules: {
        		factoryName:[
          			{ required: true, message: '请输入一个工厂名称', trigger: 'change' }
        		],
			},
			pageNum:0,
		}
	},
	methods: {
		close(){
			this.$refs['form'].resetFields()
		},
		restForm(){
			this.$nextTick(()=>{
				this.$refs['form'].resetFields()
			})
        },
        handleCurrentChange(){

        }
	}
}
</script>

<style scoped>
.title{
  text-align: left;
}
.btn{
	width: 500px;
	margin:0 100px;
}
.el-input,.el-select{
	width:220px;
}
</style>


// WEBPACK FOOTER //
// src/pages/MutualQuery.vue